<template>
  <div id="real_name_dialog_outer" v-on:click="backDivClicked">
    <div>
      <div>
        <span style="color: black;"><span class="iconfont" style="color: green;margin-right:10px;font-weight: bold;">&#xe654;</span>实名认证已通过</span>
      </div>
      <div>
        <div class="row-div">
          <div class="user-infors" >
            <span>姓名</span><br>
            <span>{{nickName}}</span>
          </div>
          <div>
            <a class="iconfont" style="font-weight: bold;font-size: 1.5rem;margin-right: 5px;color: green;">&#xe621;</a>信息安全保障中</div>
        </div>

        <div class="user-infors" style="margin-top: 30px;">
          <span>证件号码</span><br>
          <span>{{idNo}}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RealNameDialog",

  computed: {
    user() {
      return this.$store.state.user;
    },
    nickName() {
      if (this.user == null) {
        return '暂无';
      }
      let user = this.user;
      let nickName = user.name;
      if (nickName == null || nickName == '') {
        return '暂无';
      }

      let tmpArray = nickName.split("");
      let newNickName = "";
      for (let i = 0; i < tmpArray.length; i++) {
        let charItem = tmpArray[i];
         if (i < tmpArray.length - 1) {
          newNickName += "*";
        } else {
          newNickName += charItem;
        }
      }
      return newNickName;
    },
    idNo() {
      if (this.user == null) {
        return '暂无1';
      }
      let user = this.user;
      let idNo = user.idNumber;
      if (idNo == null || idNo == '') {
        return '暂无2';
      }

      let tmpArray = idNo.split("");
      let newIdNo = "";
      for (let i = 0; i < tmpArray.length; i++) {
        let charItem = tmpArray[i];
        if (i == 0) {
          newIdNo += charItem;
        } else if (i < tmpArray.length - 1) {
          newIdNo += "*";
        } else {
          newIdNo += charItem;
        }
      }

      return newIdNo;
    },
  },

  mounted() {
    console.log(this.user);
  },
  methods: {
    backDivClicked() {
      this.$emit("closeDialog");
    }
  }
}
</script>

<style scoped>

  #real_name_dialog_outer {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #real_name_dialog_outer > div {
    background-color: white;
    width: 80%;
    max-width: 400px;
    border: solid 1px lightgrey;
  }

  #real_name_dialog_outer > div > div:first-child {
    border-bottom: solid 1px lightgrey;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }

  #real_name_dialog_outer > div > div:not(:first-child) {
    padding: 40px 40px;

  }

  #real_name_dialog_outer .row-div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
  }


  #real_name_dialog_outer .user-infors span:first-child {
    /*font-size: small;*/
  }

  #real_name_dialog_outer .user-infors span:not(:first-child) {
    font-weight: bold;
    display: inline-block;
    margin-top: 3px;
  }


</style>



// WEBPACK FOOTER //
// src/components/settings/RealNameDialog.vue